import { PopoverPlacement, PopoverTriggerType } from "@idui/react-popover";
import clsx from "clsx";
import { FC } from "react";
import { useRecoilValue } from "recoil";

import { PIC } from "@ryde/assets";
import {
  HeaderCellSortableButtonWrapper,
  HeaderCelSortablePopover,
  HeaderPopoverReports,
  IHeaderPopover,
} from "@ryde/controls";
import { useReportId, useRtl } from "@ryde/redux";
import { reportsTableColumnSortingSF, SortingEnum } from "@ryde/shared";

export const HeaderCellSortableReports: FC<IHeaderPopover> = props => {
  const { isHiddenFromView, fieldNameResolved, children } = props;
  const { isRtl } = useRtl();
  const { reportId } = useReportId();

  const sorting = useRecoilValue(
    reportsTableColumnSortingSF([reportId, fieldNameResolved]),
  );

  return (
    <HeaderCellSortableButtonWrapper
      className={clsx({ is_hidden: isHiddenFromView })}
    >
      <span className="th_sortable_content">
        <HeaderCelSortablePopover
          content={<HeaderPopoverReports {...props} />}
          trigger={PopoverTriggerType.hover}
          closeOnRemoteClick
          guessBetterPosition
          placement={
            isRtl ? PopoverPlacement.topRight : PopoverPlacement.topLeft
          }
          mouseEnterDelay={300}
          mouseLeaveDelay={100}
          withArrow={false}
        >
          <button
            className="header_sortable_button"
            data-e2e="sorting-button-popover"
            data-e2e-id={`${fieldNameResolved}`}
            data-e2e-value={`sorting_${sorting}`}
          >
            <span className="th_sortable_text_wrapper">{children}</span>

            {sorting === SortingEnum.Asc && (
              <PIC.TableSortAscSVG data-e2e="sort-asc" />
            )}
            {sorting === SortingEnum.Desc && (
              <PIC.TableSortDescSVG data-e2e="sort-desc" />
            )}
          </button>
        </HeaderCelSortablePopover>
      </span>
    </HeaderCellSortableButtonWrapper>
  );
};
